import { ReactKeycloakProvider } from '@react-keycloak/web';
import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  BrowserRouter, Route, Routes
} from "react-router-dom";
import App from './App';
import PrivateRoute from './components/PrivateRoute.mjs';
import { axiosConfig } from './config/axios.config.mjs';
import { keycloak, keycloakInitOptions } from './config/keycloak.config.mjs';
import './index.css';
import Builder from './pages/Builder/Builder.js';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

axiosConfig()

root.render(
  <ReactKeycloakProvider authClient={keycloak} initOptions={keycloakInitOptions}>
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Routes>
        <Route path="/" element={<PrivateRoute><App /></PrivateRoute>} />
        <Route path="/builder" element={<PrivateRoute><Builder /></PrivateRoute>} />
      </Routes>
    </BrowserRouter>
  </ReactKeycloakProvider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
